import React from 'react'
import { createRoot } from 'react-dom/client'

import PublicApp from '../react/public/PublicApp.jsx'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('react-app')
  const root = createRoot(container)

  // window.initialData rendered in rails view for the request, in this case views/public/leaderboard.html.erb,
  // then set to a window variable in application.html.erb
  // this removes the need for an initial ajax request to populate the app with data, so that it loads more smoothly,
  // i.e. the http response that returns the react app also includes all the needed data for the first react render.
  // const initialData = camelcaseKeysDeep(window.initialData)

  window.phoneCutoffSizePx = 1000

  root.render(<PublicApp />)
})
